export function hasEmptyAnswer(
  questions: SurveyQuestionMultipleChoiceEntity[],
  answers: SurveyAnswer[]
) {
  for (const question of questions) {
    const index = answers.findIndex(a => a.questionId === question.id);
    if (index < 0) {
      return true;
    }
  }
  return false;
}

export function hasEmptyMandatoryAnswer(
  questions: SurveyQuestionMultipleChoiceEntity[],
  answers: SurveyAnswer[]
) {
  const filtered = questions.filter(q => q.mandatory);
  for (const question of filtered) {
    const index = answers.findIndex(a => a.questionId === question.id);
    if (index < 0) {
      return true;
    }
  }
  return false;
}

export function hasSelectedCountViolated(
  questions: SurveyQuestionMultipleChoiceEntity[],
  answers: SurveyAnswer[]
) {

  for (let i = 0; i < questions.length; i++) {

    const question = questions[i];
    if (!question.mandatory || !question.allowMultipleSelect) continue;
    const answer = answers.find(a => a.questionId === question.id);
    if (answer?.answerIds?.length < question.minSelectableChoices) {
      return `شما حداقل گزینه مورد نیاز در سوال ${i + 1} را انتخاب نکرده اید`;
    }

    // below condition can not be true, because of prevention in UI inputs
    if (answer?.answerIds?.length > question.maxSelectableChoices) {
      return `شما حداکثر گزینه مورد نیاز در سوال ${i + 1} را انتخاب نکرده اید`;
    }
  }

  return false;
}
